import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import Dropzone from "react-dropzone";
import NumberInput from "../Common/numberInput";
import Validator from "../Common/validator";
import { isStringValid } from "../Util/stringValidator";
import { semanticColors, greyScaleColors } from "../Globals/styles";

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productId: null,
      name: "",
      unit: "Stk",
      type: "Materiel",
      price: 0,
      dataSheet: null,
      technicalDataSheet: null,
      chemDataSheet: null,
      isTouched: false,
      deletable: true,
    };
  }

  componentWillMount = () => {
    if (this.props.defaultValue) {
      this.setState({
        ...this.state,
        ...this.props.defaultValue,
      });
    }
  };

  setDataSheet = (selectedFile) => {
    //Check File is not Empty
    if (selectedFile.length > 0) {
      // Select the very first file from list
      var fileToLoad = selectedFile[0];
      // FileReader function for read the file.
      var fileReader = new FileReader();
      var base64;
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result.split(",")[1];
        // Print data in console
        this.setState({
          dataSheet: base64,
          isTouched: true,
        });
      }.bind(this);
      // Convert data to base64
      fileReader.readAsDataURL(fileToLoad);
    }
  };

  setTechnicalDataSheet = (selectedFile) => {
    //Check File is not Empty
    if (selectedFile.length > 0) {
      // Select the very first file from list
      var fileToLoad = selectedFile[0];
      // FileReader function for read the file.
      var fileReader = new FileReader();
      var base64;
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result.split(",")[1];
        // Print data in console
        this.setState({
          technicalDataSheet: base64,
          isTouched: true,
        });
      }.bind(this);
      // Convert data to base64
      fileReader.readAsDataURL(fileToLoad);
    }
  };

  setChemDataSheet = (selectedFile) => {
    //Check File is not Empty
    if (selectedFile.length > 0) {
      // Select the very first file from list
      var fileToLoad = selectedFile[0];
      // FileReader function for read the file.
      var fileReader = new FileReader();
      var base64;
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result.split(",")[1];
        // Print data in console
        this.setState({
          chemDataSheet: base64,
          isTouched: true,
        });
      }.bind(this);
      // Convert data to base64
      fileReader.readAsDataURL(fileToLoad);
    }
  };

  onSubmit = () => {
    if (!isStringValid(this.state.name)) {
      this.setState({ isTouched: true });
    } else {
      this.props.onSubmit({
        productId: this.state.productId,
        name: this.state.name,
        unit: this.state.unit,
        type: this.state.type,
        price: this.state.price,
        dataSheet: this.state.dataSheet,
        technicalDataSheet: this.state.technicalDataSheet,
        chemDataSheet: this.state.chemDataSheet,
        deletable: this.state.deletable,
      });
    }
  };

  render() {
    const { onClose, isSubmitting, isOdd } = this.props;
    return (
      <div className="row" style={[styles.tr, isOdd && styles.trOdd]}>
        <div className="col-xs-5" style={styles.td}>
          <Validator
            isValid={!this.state.isTouched || isStringValid(this.state.name)}
          >
            <input
              style={styles.input}
              className="form-control"
              onChange={(evt) => this.setState({ name: evt.target.value })}
              value={this.state.name}
              placeholder="Skriv beskrivelse..."
              onBlur={() => this.setState({ isTouched: true })}
            />
          </Validator>
        </div>
        <div className="col-xs-1" style={styles.td}>
          <select
            style={styles.input}
            defaultValue={this.state.unit}
            onChange={(evt) => this.setState({ unit: evt.target.value })}
            onBlur={() => this.setState({ isTouched: true })}
          >
            <option value="Stk">Stk</option>
            <option value="L">L</option>
            <option value="Kg">Kg</option>
            <option value="M">M</option>
            <option value="M2">M2</option>
            <option value="M3">M3</option>
            <option value="Km">Km</option>
            <option value="Dage">Dage</option>
            <option value="Timer">Timer</option>
            <option value="Kr">Kr</option>
          </select>
        </div>
        <div className="col-xs-1" style={styles.td}>
          <select
            style={styles.input}
            defaultValue={this.state.type}
            onChange={(evt) => this.setState({ type: evt.target.value })}
            onBlur={() => this.setState({ isTouched: true })}
          >
            <option value="Materiel">Materiel</option>
            <option value="Materiale">Materiale</option>
          </select>
        </div>
        <div className="col-xs-1" style={styles.td}>
          <NumberInput
            style={styles.input}
            onChange={(val) => this.setState({ price: val })}
            value={this.state.price}
            onBlur={() => this.setState({ isTouched: true })}
          />
        </div>
        <div
          className="col-xs-1"
          style={[styles.td, { lineHeight: "1em", textAlign: "center" }]}
        >
          {this.state.dataSheet === "delete" ||
          this.state.dataSheet === "none" ||
          this.state.dataSheet === "pending" ||
          this.state.dataSheet === null ? (
            <label
              htmlFor="inp"
              style={[
                styles.iconsContainer,
                {
                  display: "table",
                  margin: "0 auto",
                  float: "center",
                  cursor: "pointer",
                },
              ]}
            >
              <Dropzone
                style={{ height: "100%", width: "100%", position: "absolute" }}
                onDrop={this.setDataSheet.bind(this)}
              >
                <i
                  aria-hidden="true"
                  className="fa fa-cloud-upload"
                  style={styles.icon}
                />
                <div
                  style={{
                    fontSize: "8px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Upload ny
                </div>
              </Dropzone>
            </label>
          ) : (
            <div
              style={[
                styles.iconsContainer,
                {
                  display: "table",
                  margin: "0 auto",
                  float: "center",
                  cursor: "default",
                },
              ]}
            >
              <i
                aria-hidden="true"
                className="fa fa-file-pdf-o"
                style={styles.icon}
              />
              <div style={styles.label}>datablad</div>
              <i
                className="fa fa-minus-circle"
                aria-hidden="true"
                onClick={() =>
                  this.setState({ dataSheet: "delete", isTouched: true })
                }
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: "0",
                  right: "25",
                }}
              />
            </div>
          )}
        </div>
        <div
          className="col-xs-1"
          style={[styles.td, { lineHeight: "1em", textAlign: "center" }]}
        >
          {this.state.technicalDataSheet === "delete" ||
          this.state.technicalDataSheet === "none" ||
          this.state.technicalDataSheet === "pending" ||
          this.state.technicalDataSheet === null ? (
            <label
              htmlFor="inp"
              style={[
                styles.iconsContainer,
                {
                  display: "table",
                  margin: "0 auto",
                  float: "center",
                  cursor: "pointer",
                },
              ]}
            >
              <Dropzone
                style={{ height: "100%", width: "100%", position: "absolute" }}
                onDrop={this.setTechnicalDataSheet.bind(this)}
              >
                <i
                  aria-hidden="true"
                  className="fa fa-cloud-upload"
                  style={styles.icon}
                />
                <div
                  style={{
                    fontSize: "8px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Upload ny
                </div>
              </Dropzone>
            </label>
          ) : (
            <div
              style={[
                styles.iconsContainer,
                {
                  display: "table",
                  margin: "0 auto",
                  float: "center",
                  cursor: "default",
                },
              ]}
            >
              <i
                aria-hidden="true"
                className="fa fa-file-pdf-o"
                style={styles.icon}
              />
              <div style={styles.label}>Datablad</div>
              <i
                className="fa fa-minus-circle"
                aria-hidden="true"
                onClick={() =>
                  this.setState({
                    technicalDataSheet: "delete",
                    isTouched: true,
                  })
                }
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: "0",
                  right: "25",
                }}
              />
            </div>
          )}
        </div>
        <div
          className="col-xs-1"
          style={[styles.td, { lineHeight: "1em", textAlign: "center" }]}
        >
          {this.state.chemDataSheet === "delete" ||
          this.state.chemDataSheet === "none" ||
          this.state.chemDataSheet === "pending" ||
          this.state.chemDataSheet === null ? (
            <label
              htmlFor="inp2"
              style={[
                styles.iconsContainer,
                {
                  display: "table",
                  margin: "0 auto",
                  float: "center",
                  cursor: "pointer",
                },
              ]}
            >
              <i
                aria-hidden="true"
                className="fa fa-cloud-upload"
                style={styles.icon}
              />
              <div
                style={{
                  fontSize: "8px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              >
                Upload ny
              </div>
              <input
                id="inp2"
                style={{ display: "none" }}
                type="file"
                accept="application/pdf"
                onChange={(e) => this.setChemDataSheet(e.target.files)}
                onBlur={() => this.setState({ isTouched: true })}
              />
            </label>
          ) : (
            <div
              style={[
                styles.iconsContainer,
                {
                  display: "table",
                  margin: "0 auto",
                  float: "center",
                  cursor: "default",
                },
              ]}
            >
              <i
                aria-hidden="true"
                className="fa fa-file-pdf-o"
                style={styles.icon}
              />
              <div style={styles.label}>Datablad</div>
              <i
                className="fa fa-minus-circle"
                aria-hidden="true"
                onClick={() =>
                  this.setState({
                    chemDataSheet: "delete",
                    isTouched: true,
                  })
                }
                style={{
                  position: "absolute",
                  cursor: "pointer",
                  top: "0",
                  right: "25",
                }}
              />
            </div>
          )}
        </div>
        <div className="col-xs-1" style={[styles.td, styles.lastInTr]}>
          <div
            className="waves-btn"
            style={styles.iconsContainer}
            onClick={onClose}
          >
            <i className="fa fa-ban" aria-hidden="true" style={styles.icon}></i>
            <div style={styles.label}>Luk</div>
          </div>
          <div
            className="waves-btn"
            style={styles.iconsContainer}
            onClick={this.onSubmit}
          >
            {isSubmitting ? (
              <i className="fa fa-spinner fa-spin" style={styles.icon} />
            ) : (
              <i
                className="fa fa-floppy-o"
                aria-hidden="true"
                style={styles.icon}
              ></i>
            )}
            <div style={styles.label}>{isSubmitting ? "Gemmer..." : "Gem"}</div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  tr: {
    margin: "0",
    height: "40px",
    backgroundColor: "#EBEEF0",
  },
  td: {
    textAlign: "right",
    borderRight: "1px solid " + semanticColors.mainBackground,
    padding: "0",
    height: "100%",
    lineHeight: "40px",
  },
  trOdd: {
    backgroundColor: semanticColors.primaryLight,
  },
  input: {
    width: "100%",
    height: "40px",
    boxShadow:
      "0 1px 6px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset",
    borderRadius: "0",
    "-webkit-appearance": "none",
    border: "none",
  },
  lastInTr: {
    borderRight: "none",
    textAlign: "center",
    lineHeight: "1em",
    padding: "0 12px 0 5px",
  },
  icon: {
    fontSize: "20px",
    display: "block",
  },
  iconsContainer: {
    float: "left",
    color: greyScaleColors.greyLight,
    textAlign: "center",
    width: "50%",
    height: "40px",
    paddingTop: "3px",
    position: "relative",
    cursor: "pointer",
  },
  iconsContainerActive: {
    color: semanticColors.info,
  },
  label: {
    fontSize: "8px",
    position: "absolute",
    top: "23px",
    width: "100%",
    fontWeight: "600",
  },
};
Create.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  defaultValue: PropTypes.object,
  isOdd: PropTypes.bool.isRequired,
};
export default Radium(Create);



// WEBPACK FOOTER //
// ./src/App/Product/Create.jsx